export default __webpack_public_path__ + "static/media/topicNew1.a8d6b323.jpg";